import React from 'react';

interface PageShellProps {
  children: React.ReactNode;
  title?: React.ReactNode;
  actions?: React.ReactNode;
  width?: 'wide' | 'narrow';
  surface?: 'app' | 'white';
  bottomNav?: boolean;
  className?: string;
  /** Public iframe embed: no app chrome, height follows content. */
  embed?: boolean;
}

export const PageShell = ({
  children,
  title,
  actions,
  width = 'wide',
  surface = 'app',
  bottomNav = true,
  className,
  embed = false,
}: PageShellProps) => (
  <div
    {...(embed ? { 'data-iframe-height': '' } : {})}
    className={`${embed ? 'min-h-0' : `min-h-svh pt-header ${bottomNav ? 'pb-tabbar' : ''}`} ${
      surface === 'white' ? 'bg-white' : 'bg-[#F5F7F9]'
    } ${className || ''}`}
  >
    <div
      className={`w-full mx-auto px-[16px] sm:px-[24px] lg:px-[136px] ${
        width === 'narrow' ? 'xl:px-[276px]' : ''
      } py-[24px] sm:py-[32px] lg:py-[36px] space-y-[20px] lg:space-y-[24px]`}
    >
      {(title || actions) && (
        <div className="flex flex-col gap-[16px] lg:flex-row lg:items-center lg:justify-between">
          {title && (
            <h1 className="text-[26px] leading-[32px] lg:text-3xl font-medium text-[#2E435F]">
              {title}
            </h1>
          )}
          {actions && (
            <div className="flex flex-col md:flex-row md:items-center gap-[12px]">
              {actions}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  </div>
);
